import api from './api';

const vaultsourcegroupvaulttableService = {
  // Add vault tables to a vault source group
  addVaultTablesToGroup: async (vaultsourcegroupid, vaulttableids) => {
    const response = await api.post('/vaultsourcegroupvaulttable', {
      vaultsourcegroupid,
      vaulttableids
    });
    return response.data;
  },

  // Get vault tables for a vault source group
  getVaultTablesForGroup: async (vaultsourcegroupid) => {
    const response = await api.get(`/vaultsourcegroupvaulttable?vaultsourcegroupid=${vaultsourcegroupid}`);
    return response.data;
  },

  // Remove a vault table from a vault source group
  removeVaultTableFromGroup: async (junctionId) => {
    const response = await api.delete(`/vaultsourcegroupvaulttable/${junctionId}`);
    return response.data;
  }
};

export default vaultsourcegroupvaulttableService;
